module.exports = __webpack_public_path__ + "img/gb13871-92_130x160x12.prt.3338e3f6.jpg";